// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline-headers h2{display:inline}.inline-headers .fa-info-circle{font-size:16px}`, "",{"version":3,"sources":["webpack://./app/javascript/components/ProjectStatusBar/ProjectStatusBar.scss"],"names":[],"mappings":"AAGE,mBACE,cAAA,CAGF,gCACE,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
